<template>
    <div class="logos">
        <ul class="list">
            <li
                v-for="(logo, key) in data.logos"
                :key="key"
                class="list-item"
            >
                <a :href="logo.link">
                    <CmsImage
                        :data="logo.image"
                        class="cms-image"
                    />
                </a>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import type { ComponentLogosFragment } from '@/graphql/api'

import CmsImage from '@/components/cms/CmsImage.vue'

defineProps<{
    data: ComponentLogosFragment
}>()
</script>

<style lang="scss" scoped>
.logos {
    width: 100%;

    .list {
        width: 100%;
        max-width: 1140px;
        list-style: none;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        padding: 40px 20px 30px;

        .list-item {
            width: 33.33%;
            padding: 20px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 20px 0;

            height: 30px;

            @include min-width(410) {
                height: 40px;
            }

            @include min-width(640) {
                width: 33.33%;
            }

            @include min-width(1024) {
                width: 15%;
                height: 50px;
            }
        }
    }
}
</style>
